import SessionJournal from '../SessionJournal';
import NutritionAI from '../NutritionAI';
import AICoach from '../AICoach';
import ExerciseLibrary from '../ExerciseLibrary';
import LifeCoach from '../LifeCoach';

export default function AICoachTab({ childId, childName }) {
  return (
    <div className="space-y-6" data-testid="ai-coach-tab">
      {/* AI Life Coach - Personal Development & Mental Performance */}
      <LifeCoach 
        childId={childId}
        childName={childName}
      />
      
      {/* Session Journal - Conversational AI for documenting training/matches */}
      <SessionJournal 
        childId={childId}
        childName={childName}
      />
      
      {/* AI Nutrition Coach - Evidence-based meal recommendations */}
      <NutritionAI 
        childId={childId}
        childName={childName}
      />
      
      <div className="bg-zinc-950/30 border border-zinc-800 backdrop-blur-sm p-6">
        <AICoach 
          childId={childId}
          childName={childName}
        />
      </div>
      
      {/* Exercise Library - Integrated with AI Coach */}
      <ExerciseLibrary 
        childId={childId}
        childName={childName}
      />
    </div>
  );
}
